import { Route, Routes } from 'react-router-dom';
import ServiceBundle from '../child_components/ServiceBundle';
import ServiceList from '../child_components/ServiceList';
import MaterialList from '../child_components/MaterialList';
import OtherList from '../child_components/OtherList';

function Services() {

    return(
        <div>
            <Routes>
                    <Route path='/service_bundle' element={ <ServiceBundle /> } />
                    <Route path='/service_list' element={ <ServiceList /> } />
                    <Route path='/material_list' element={ <MaterialList /> } />
                    <Route path='/other' element={ <OtherList /> } />
            </Routes>
        </div>
    )
}

export default Services;